<template>
  <div class="input-multiple-choice">
    <input-button
      v-for="(choice, key) in choices"
      :key="key"
      :class="key === 0 ? '' : 'mt-2'"
      :state="choice.value === innerValue ? 'active' : ''"
      @click="innerValue = choice.value"
    >
      <markdown-text>{{ getChoiceLabel(choice) }}</markdown-text>
    </input-button>
  </div>
</template>

<script>

import { mapState } from 'pinia';
import { useSurveyStore } from '@/store';
import InputComponent from '../InputComponent';
import InputButton from '../common/InputButton/InputButton';
import MarkdownText from '../../common/MarkdownText';

export default {
  name: 'InputMultipleChoice',
  components: { MarkdownText, InputButton },
  extends: InputComponent,
  props: {
    modelValue: {
      type: [Number, String, Array],
      required: false,
      default: 0,
    },
    choices: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      innerValue: 0,
    };
  },
  computed: {
    ...mapState(useSurveyStore, ['showQuestionAnswerIds']),
  },
  watch: {
    modelValue() {
      let newInnerValue = this.modelValue;

      if (newInnerValue instanceof Array) {
        // eslint-disable-next-line prefer-destructuring
        newInnerValue = newInnerValue[0];
      }

      if (newInnerValue === this.innerValue) {
        return;
      }

      this.innerValue = newInnerValue;
    },
    innerValue() {
      let newValue = this.innerValue;

      if (newValue instanceof Array) {
        // eslint-disable-next-line prefer-destructuring
        newValue = newValue[0];
      }

      if (newValue === this.modelValue) {
        return;
      }

      this.$emit('update:modelValue', newValue);
    },
  },
  mounted() {
    this.innerValue = this.modelValue;
  },
  methods: {
    getChoiceLabel(choice) {
      if (this.showQuestionAnswerIds) {
        return `${choice.value} - ${choice.label}`;
      }

      return choice.label;
    },
  },
};

</script>
